var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:_vm.svgClass,attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('title',[_vm._v(_vm._s(_vm.title))]),_c('use',{attrs:{"xlink:href":_vm.iconName}})])}
var staticRenderFns = []

export { render, staticRenderFns }